import ViewBlog from "./ViewBlog";

export default ViewBlog;